// const fetchIPAndCountry = async () => {
//     try {
//       const response = await fetch('https://ipinfo.io/json?token=b806926d439ffc');
//       const data = await response.json();
//       return {
//         ip: data.ip,
//         country: data.country,
//         region: data.region
//       };
//     } catch (error) {
//       console.error('Error fetching IP and country:', error);
//       return {
//         ip: '',
//         country: '',
//         region: ''
//       };
//     }
//   };

// const generateEventID = () => {
//   return `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
// };

export const trackPageView = async (location, userData) => {
  // const customerInfo = await fetchIPAndCountry();
  const pageName =
    location.pathname === "/"
      ? "Home Page"
      : `${location.pathname.substring(1)} Page`;
  // Facebook Pixel tracking
  // window.fbq('trackCustom', pageName, {
  //
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //   client_email: customerInfo.email
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", "page_view", {
    event_name: "Page View",
    event_label: pageName,

    page_location: window.location.href,
    // client_ip_address: customerInfo.ip,
    // client_user_agent: navigator.userAgent,
    // client_country: customerInfo.country,
    // client_region: customerInfo.region,
    // client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
    // client_email: userData ? userData?.email : 'Guest'
  });
};
export const trackViewContent = async (contentType, userData) => {
  // const customerInfo = await fetchIPAndCountry();

  // Facebook Pixel tracking
  // window.fbq('track', 'ViewContent', {
  //   content_ids: [contentId],
  //   content_type: contentType,
  //
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //   client_email: customerInfo.email
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", contentType, {
    event_label: contentType,
    event_name: "View Content",
    // client_ip_address: customerInfo.ip,
    // client_user_agent: navigator.userAgent,
    // client_country: customerInfo.country,
    // client_region: customerInfo.region,
    //    client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
    // client_email: userData ? userData?.email : 'Guest'
  });
};

export const trackAddToCart = async (
  productId,
  productName,
  productPrice,
  eventType,
  userData,
) => {
  // const customerInfo = await fetchIPAndCountry();

  // Facebook Pixel tracking
  // window.fbq('track', 'AddToCart', {
  //   content_ids: [productId],
  //   content_type: productName,
  //   value: productPrice,
  //
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //      client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
  //client_email: userData ? userData?.email : 'Guest'
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", eventType, {
    event_category: eventType,
    event_label: productName,
    items: [
      {
        id: productId,
        name: productName,
        price: productPrice,
      },
    ],
    event_name: "Add to Cart",
    value: productPrice,
    // client_ip_address: customerInfo.ip,
    // client_user_agent: navigator.userAgent,
    // client_country: customerInfo.country,
    // client_region: customerInfo.region,
    //    client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
    // client_email: userData ? userData?.email : 'Guest'
  });
};

export const trackAddToWishlist = async (
  productId,
  productName,
  eventType,
  userData,
) => {
  // const customerInfo = await fetchIPAndCountry();

  // Facebook Pixel tracking
  // window.fbq('track', 'AddToWishlist', {
  //   content_ids: [productId],
  //   content_type: productName,
  //
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //      client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
  //client_email: userData ? userData?.email : 'Guest'
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", eventType, {
    event_category: eventType,
    event_label: productName,
    items: [
      {
        id: productId,
        name: productName,
      },
    ],
    event_name: "Add to Wishlist",
    // client_ip_address: customerInfo.ip,
    // client_user_agent: navigator.userAgent,
    // client_country: customerInfo.country,
    // client_region: customerInfo.region,
    // client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
    // client_email: userData ? userData?.email : 'Guest'
  });
};

export const trackCompleteRegistration = async (
  status,
  email,
  name,
  registerType,
) => {
  // const customerInfo = await fetchIPAndCountry();

  // Facebook Pixel tracking
  // window.fbq('track', 'CompleteRegistration', {
  //
  //   status: status, // 'success' or 'failure'
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //   client_email: email || customerInfo.email
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", `${registerType}`, {
    event_category: registerType,
    event_status: status,
    method: "email",
    event_name: "Registration",

    // client_ip_address: customerInfo.ip,
    // client_user_agent: navigator.userAgent,
    // client_country: customerInfo.country,
    // client_region: customerInfo.region,
    // client_name: name || 'Guest',
    // client_email: email  || 'Guest'
  });
};
export const trackPurchase = (
  transactionId,
  value,
  orderType,
  currency = "NGN",
) => {
  window.dataLayer.push({
    event: "purchase",
    value,
    currency,
    transaction_id: transactionId,
    order_type: orderType,
  });
};

export const trackInitiateCheckout = async (
  status,
  eventType,
  itemCount,
  contents,
  userData,
) => {
  // const customerInfo = await fetchIPAndCountry();

  // Facebook Pixel tracking
  // window.fbq('track', 'InitiateCheckout', {
  //   status: status,
  //   num_items: itemCount,
  //   contents: contents,
  //
  //   client_ip_address: customerInfo.ip,
  //   client_user_agent: navigator.userAgent,
  //   client_country: customerInfo.country,
  //   client_region: customerInfo.region,
  //      client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
  // client_email: userData ? userData?.email : 'Guest'
  // });

  // Google Analytics tracking
  window.dataLayer.push("event", eventType, {
    event_category: eventType,
    event_status: status,
    items: contents,
    event_name: "Initiate Checkout",
    num_items: itemCount,
    //   client_ip_address: customerInfo.ip,
    //   client_user_agent: navigator.userAgent,
    //   client_country: customerInfo.country,
    //   client_region: customerInfo.region,
    //  client_name:  userData ? `${userData?.firstName} ${userData?.lastName}` : 'Guest',
    //   client_email: userData ? userData?.email : 'Guest'
  });
};
